import React from "react";
import { Svg, Path, Rect, Text as SvgText } from "@react-pdf/renderer";

const PdfIcon = () => (
  <Svg style={{ width: 26, height: 30 }}>
    {/* Page */}
    <Rect x="1" y="1" width="24" height="28" rx="2" ry="2" fill="#ffffff" stroke="#c9c9c9" />
    {/* Folded corner */}
    <Path d="M19 1 L25 7 L19 7 Z" fill="#e9e9e9" stroke="#c9c9c9" />
    {/* Red bar */}
    <Rect x="3" y="18" width="20" height="9" rx="1" ry="1" fill="#d32f2f" />
    {/* PDF text */}
    <SvgText
      x="13"
      y="25"
      style={{
        fontSize: 7,
        fill: "#ffffff",
        textAnchor: "middle",
        fontWeight: 700,
      }}
    >
      PDF
    </SvgText>
  </Svg>
);

export default PdfIcon;
